import upload from '@caxa-form/component-antdv-upload/src/index'
import frame from '@caxa-form/component-antdv-frame/src/index'
import group from '@caxa-form/component-antdv-group/src/index'
import subForm from '@caxa-form/component-subform/src/index'

export default [
    upload, frame, group, subForm
]
